<template>
<div style="width: 920px; margin: 0; padding: 0;">
  <tr style="width: 920px;">
    <td :style="{ paddingLeft: subjectTypeId === '' ? `${item.subjectLevel * 5}px` : 0 }" style="width: 150px; text-align: left" @click="toggle">
      <span v-if="subjectTypeId === ''" class="toggle-btn" :class="{'none': !(item.children && item.children.length)}">
        {{ isOpen ? '-' : '+' }}
      </span>
      {{ item.subjectCode }}
    </td>
    <td style="width: 150px; text-align: left;">{{ item.subjectName }}</td>
    <td style="text-align: right; width: 140px;">{{ item.unit}}</td>
    <td style="text-align: right; width: 130px;">
      <div v-if="item.leafFlag === '0'">
        {{  Number(item.beforeAdjustNum).toFixed(2) }}
      </div>
    </td>
    <td style="text-align: right; width: 100px;">
      <div v-if="item.leafFlag === '0'">
        {{  Number(item.beforeAdjustUnitPrice).toFixed(2) }}
      </div>
    </td>
    <td style="text-align: right; width: 100px;">{{ Number(item.beforeAdjustAmount).toFixed(2) }}</td>
    <td class="over" style="width: 150px;" @click="showDetail(item.remarks)">
      <div style="width: 100%;overflow: hidden;white-space: nowrap; text-overflow: ellipsis; text-align: left; padding: 6px; box-sizing: border-box">{{ item.remarks }}</div>
    </td>
  </tr>
  <tr v-if="isOpen">
    <td colspan="10" class="child-rows">
<!--      <table>-->
<!--        <tbody>-->
        <tree-row v-for="child in item.children" :key="child.id" :item="child" />
<!--        </tbody>-->
<!--      </table>-->
    </td>
  </tr>
</div>
</template>

<script>
import Decimal from "decimal.js";
export default {
  name: 'TreeRow',
  props: {
    item: {
      type: Object,
      required: true
    },
    subjectTypeId: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      isOpen: true
    };
  },
  computed: {
    level() {
      return this.item.level || 0;
    }
  },
  methods: {
    toggle() {
      this.isOpen = !this.isOpen;
    },
    handleAction() {
      console.log(`操作: ${this.item.name}`);
    },
    // 计算差额
    CalculateDiff(row){
      return new Decimal(row.currentAnnualBudgetAmount).sub(new Decimal(row.preAnnualPaidAmount)).toFixed(2, Decimal.ROUND_HALF_UP)
    },
    // 计算差额百分比
    CalculateDiffPercent(row){
      if(new Decimal(row.preAnnualPaidAmount).eq(0)) {
        return new Decimal(0).toFixed(2, Decimal.ROUND_HALF_UP) + '%'
      } else {
        return (new Decimal(row.currentAnnualBudgetAmount).sub(new Decimal(row.preAnnualPaidAmount))).mul(100).div(new Decimal(row.preAnnualPaidAmount)).toFixed(2, Decimal.ROUND_HALF_UP) + '%'
      }
    },
    showDetail(content) {
      if(content === '') {
        return
      }
      this.$dialog.alert({
        message: content,
        confirmButtonColor: '#409EFF'
      })
    }
  }
};
</script>

<style scoped>
.toggle-btn {
  cursor: pointer;
  margin-right: 5px;
}

.child-rows {
  padding: 0;
  margin: 0;
  border: 0;
  /*background-color: #f9f9f9;*/
}

.over {
  padding: 0!important;
  /*display: flex;*/
  /*justify-content: center;*/
  /*align-items: center;*/
}

.none {
  opacity: 0;
}
</style>
